<template>
  <b-container class="home-container text-left container-xl">
    <b-row class="mb-3">
      <b-col sm="12" md="12 mb-lg-4">
        <h1 class="mb-lg-3">Útmutatók, kézikönyvek, segédletek</h1>
      </b-col>
    </b-row>
    <div class="pb-1 pt-5">
      <h1>MGFÜ saját kiadványai</h1>
      <b-container class="text-left" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="pl-4 d-lg-flex justify-content-end d-none order-lg-2">
            <img src="../assets/img/publication-1.jpg" class="img-style-3" />
          </b-col>
          <b-col cols="12" lg="10" class="d-flex flex-column justify-content-center text-maximized-2 pb-5 order-lg-1">
            <h3>A magyar kkv-k ESG jó gyakorlatai és az MGFÜ ESG tevékenysége kiadvány</h3>
            <div class="text-content">
              <p class="pt-4">
                A Magyar Gazdaságfejlesztési Ügynökség célkitűzése a magyar vállalkozások versenyképességének növelése,
                a vállalkozói kultúra fejlesztése, és az ESG-vel kapcsolatos tudás bővítése. A kkv-k és a piaci igények
                megismerése érdekében az MGFÜ ESG felmérést végzett a hazai kkv-k között az ESG adatszolgáltatási
                kitettségről, környezeti-társadalmi és vállalatirányítási fókuszterületekről, elemezte ESG és
                fenntarthatósági felkészültségüket, kapacitásaikat és szolgáltatások iránti igényeiket. A kiadvány a
                felmérés módszertanát és eredményeit mutatja be, kézzel fogható vállalati jó gyakorlatokkal.<br />
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/ESG_kompetencia_kozpont_kiadvany.pdf" target="_blank">
                Tovább az MGFÜ kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="pl-4 d-lg-flex justify-content-end d-none order-lg-2">
            <img src="../assets/img/publication-2.svg" class="img-style-3" />
          </b-col>
          <b-col cols="12" lg="10" class="d-flex flex-column justify-content-center text-maximized-2 pb-5 order-lg-1">
            <h3>ESG alapok 1: Vállalati fenntarthatósági és ESG alapfogalmak, jogszabályi háttér ismertetése</h3>
            <div class="text-content">
              <p class="pt-4">
                A kiadvány átfogó képet ad a vállalati fenntarthatóság és az ESG (környezeti, társadalmi és irányítási
                felelősségvállalás) alapjairól. Bemutatja a legfontosabb hazai és nemzetközi szabályozási kereteket,
                miközben rávilágít arra is, hogy a fenntarthatóság hogyan válik a vállalkozások mindennapi működésének
                szerves részévé. Segítséget nyújt továbbá a KKV-k számára eligazodni a kapcsolódó elvárások és
                kötelezettségek között.<br />
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/ESG_alapok_1.pdf" target="_blank">
                Tovább az MGFÜ kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="pl-4 d-lg-flex justify-content-end d-none order-lg-2">
            <img src="../assets/img/publication-3.svg" class="img-style-3" />
          </b-col>
          <b-col cols="12" lg="10" class="d-flex flex-column justify-content-center text-maximized-2 pb-5 order-lg-1">
            <h3>
              ESG alapok 2: ESG kritériumok és jelentéstételi rendszerek, ESG tevékenység közzététele és minősítések
              megszerzése
            </h3>
            <div class="text-content">
              <p class="pt-4">
                A kiadvány az ESG három pillérének – környezeti, társadalmi és irányítási szempontok –bemutatásán
                keresztül segíti a KKV-kat az elvárások közötti eligazodásban. Közérthetően ismerteti az önkéntes és
                kötelező jelentéstételi szabványokat, valamint az ESG-tevékenységek közzétételének lehetséges formáit.
                Gyakorlati támpontot ad ahhoz, hogy a vállalkozások átláthatóan, a szabályozási elvárásoknak
                megfelelőenés üzleti céljaikkal összhangban tudják bemutatni fenntarthatósági teljesítményüket.<br />
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/ESG_alapok_2_jav.pdf" target="_blank">
                Tovább az MGFÜ kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="pl-4 d-lg-flex justify-content-end d-none order-lg-2">
            <img src="../assets/img/publication-4.svg" class="img-style-3" />
          </b-col>
          <b-col cols="12" lg="10" class="d-flex flex-column justify-content-center text-maximized-2 pb-5 order-lg-1">
            <h3>ESG alapok 3: Adatgyűjtés és elemzés, adatszolgáltatás</h3>
            <div class="text-content">
              <p class="pt-4">
                A kiadvány támogatást nyújt a KKV-k számára abban, hogy strukturált megközelítést alakítsanak ki az
                ESG-vel kapcsolatos adatok gyűjtésére, rendszerezésére és elemzésére. Bemutatja a releváns adatgyűjtési
                módszertanokat és eszközöket, segítve az átlátható és következetes működés kialakítását. A kialakított
                keretrendszer a későbbiekben gyakorlati alkalmazásra is alkalmas, így hatékonyan támogathatja a
                vállalkozások mindennapi működését és felkészülését a fenntarthatósági elvárásokra.<br />
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/ESG_alapok_3.pdf" target="_blank">
                Tovább az MGFÜ kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="pl-4 justify-content-end order-lg-2">
            <img src="../assets/img/publication-5.jpg" class="img-style-4 d-none d-lg-block" />
          </b-col>
          <b-col cols="12" lg="10" class="d-flex flex-column justify-content-center text-maximized-2 pt-5 order-lg-1">
            <h3>A KKV-k önkéntes fenntarthatósági jelentésételi szabványa (VSME)</h3>
            <div class="text-content">
              <p class="pt-4">
                A kis- és középvállalkozások számára egyre fontosabbá válik a fenntarthatósági elvárásoknak való
                megfelelés. Ebben nyújt segítséget az Európai Bizottság által ajánlott, és rendeleti szinten bevezetésre
                kerülő önkéntes fenntarthatósági jelentéstételi szabvány, a VSME. A kiadvány bemutatja a VSME
                keretrendszerét, fő követelményeit, valamint gyakorlati alkalmazási példákat is tartalmaz. Lépésről
                lépésre végigvezeti a vállalkozásokat a VSME-jelentés elkészítésének folyamatán, és segítséget ad ahhoz
                is, hogyan lehet a VSME alkalmazásával egyidejűleg megfelelni a hazai ESG-törvény és az MNB
                elvárásainak. A kiadvány emellett azoknak a vállalkozásoknak is hasznos támogatást nyújt, amelyeknek –
                például beszállítóként – EcoVadis minősítéssel kell rendelkezniük, mivel az értékelési folyamat során a
                VSME szerinti jelentéstételt is figyelembe veszik.<br />
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/ESG_modul_12_jav_VSME.pdf" target="_blank">
                Tovább az MGFÜ kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="pb-1 pt-5">
      <h1>További segédletek</h1>
      <b-container class="text-left 1" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="pl-4 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/VSME Standard.png" class="img-fluid img-style" />
          </b-col>
          <b-col cols="12" lg="10" class="d-flex flex-column justify-content-center text-maximized pb-5">
            <h3>EFRAG Önkéntes Fenntarthatósági Jelentéstételi Szabvány tőzsdén nem jegyzett KKV-k számára</h3>
            <div class="text-content">
              <p class="short-text">
                A VSME Standard egy önkéntesen alkalmazható, nemzetközi szemléletű útmutató, amely a mikro-, kis- és
                középvállalkozások számára kínál gyakorlatias eszközt az ESG szempontok működésbe való beépítésére. A
                dokumentum lehetőséget ad arra, hogy a vállalkozások önértékelés alapján megismerjék fenntarthatósági
                teljesítményüket, és elinduljanak a tudatos, hosszú távon is versenyképes működés felé...<br />
              </p>
              <p class="full-text" style="display: none;">
                A VSME Standard egy önkéntesen alkalmazható, nemzetközi szemléletű útmutató, amely a mikro-, kis- és
                középvállalkozások számára kínál gyakorlatias eszközt az ESG szempontok működésbe való beépítésére. A
                dokumentum lehetőséget ad arra, hogy a vállalkozások önértékelés alapján megismerjék fenntarthatósági
                teljesítményüket, és elinduljanak a tudatos, hosszú távon is versenyképes működés felé. A magyar nyelvű
                fordítás megkönnyíti a dokumentum értelmezését és gyakorlati alkalmazását a hazai kkv-k számára,
                elősegítve az ESG-elvek beépítését a napi döntéshozatalba. Különösen hasznos azoknak a vállalkozásoknak,
                amelyek beszállítói láncokhoz kapcsolódnak, pályázati vagy finanszírozási forrásokat szeretnének
                bevonni, illetve átlátható módon szeretnék kommunikálni fenntarthatósági elkötelezettségüket. <br />
              </p>
            </div>
            <span>
              <a
                class="link-text"
                href="https://eur-lex.europa.eu/legal-content/HU/TXT/HTML/?uri=OJ:L_202501710"
                target="_blank"
              >
                A jogszabály hivatalos magyar nyelvű fordítás elérhető az eur-lex oldalán <br />
              </a>
              <a class="link-text" href="https://vali.hu/static/EFRAG_VSME_Standard_hun.pdf" target="_blank">
                Tovább az MGFÜ kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 2" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/ESG_Utmutato_Kockazatkezeles_boritokep.webp" class="img-fluid img-style" />
          </b-col>
          <b-col cols="12" lg="10" class="text-maximized custom-col pb-5">
            <h3>Kockázatkezelés – ESG Útmutató</h3>
            <div class="text-content">
              <p class="short-text">
                A Szabályozott Tevékenységek Felügyeleti Hatósága az ESG Útmutató kiadványsorozat első részének
                elkészítésével azt a célt kívánja támogatni, hogy a hazai vállalatok közérthető, szabályozási keretekhez
                illeszkedő és a gyakorlatban is használható útmutatást kapjanak ESG-vel kapcsolatos feladataik
                ellátásához. Magyarország a nemzeti ESG szabályozás kialakításakor tudatosan racionális megközelítést
                választott, amelyben a fenntarthatósági szempontok a megfelelő helyre, a vállalati kockázatkezelési
                rendszerbe kerültek...
              </p>
              <p class="full-text" style="display: none;">
                A Szabályozott Tevékenységek Felügyeleti Hatósága az ESG Útmutató kiadványsorozat első részének
                elkészítésével azt a célt kívánja támogatni, hogy a hazai vállalatok közérthető, szabályozási keretekhez
                illeszkedő és a gyakorlatban is használható útmutatást kapjanak ESG-vel kapcsolatos feladataik
                ellátásához. Magyarország a nemzeti ESG szabályozás kialakításakor tudatosan racionális megközelítést
                választott, amelyben a fenntarthatósági szempontok a megfelelő helyre, a vállalati kockázatkezelési
                rendszerbe kerültek. Ehhez szolgál iránymutatásként az SZTFH által közzétett szakmai anyag. A kiadvány
                kézzelfogható segítséget nyújt a vállalatoknak, konkrét ajánlásokat fogalmaz meg a kockázatkezelés
                lépéseinek meghatározásához, és útmutatást ad a jelenlegi szabályozási környezet értelmezéséhez.
              </p>
            </div>
            <span>
              <a
                class="link-text"
                href="https://sztfh.hu/downloads/esg/tudastar/esg_utmutato_kockazatkezeles.pdf "
                target="_blank"
              >
                Tovább az útmutatóhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 3" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img
              src="../assets/img/3_ESG_Utmutato_Egyuttmukodes_az_ellatasi_lancban_boritokep.jpeg"
              class="img-fluid img-style"
            />
          </b-col>
          <b-col cols="12" lg="10" class="text-maximized custom-col mb-5 pb-5">
            <h3>Együttműködés az ellátási láncban - ESG Útmutató</h3>
            <div class="text-content">
              <p>
                A Szabályozott Tevékenységek Felügyeleti Hatósága által kiadott ESG Útmutató kiadványsorozat második,
                Együttműködés az ellátási láncban című kötete ajánlásokat fogalmaz meg a törvény hatálya alá tartozó
                vállalkozások és szállítóik számára az ESG elvek szerinti együttműködés kialakítására, valamint
                rávilágít az együttműködés lehetséges kihívásaira és előnyeire.
              </p>
            </div>
            <span>
              <a
                class="link-text"
                href="https://sztfh.hu/downloads/esg/tudastar/esg_utmutato_egyuttmukodes_az_ellatasi_lancban.pdf"
                target="_blank"
              >
                Tovább az útmutatóhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 4" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/4_SZTFH_Panaszkezeles.jpg" class="img-fluid img-style" />
          </b-col>
          <b-col cols="12" lg="10" class="custom-col text-maximized mb-4 pb-5">
            <h3>Panaszkezelés – ESG Útmutató</h3>
            <div class="text-content">
              <p>
                A Szabályozott Tevékenységek Felügyeleti Hatósága által kiadott ESG Útmutató kiadványsorozat harmadik,
                Panaszkezelés című kötetének célja, hogy segítse a vállalatokat az ESG törvény által előírt
                kötelezettségeik, ez esetben ESG szemléletű panaszkezelési rendszerük felállítása és működtetése kapcsán
                felmerülő feladataik megértésében és végrehajtásában. Jelen útmutató kapaszkodót nyújt azoknak, akik
                ESG-panaszkezelési rendszerük kialakításán dolgoznak
              </p>
            </div>
            <span>
              <a
                class="link-text"
                href="https://sztfh.hu/downloads/esg/tudastar/esg_utmutato_panaszkezeles.pdf"
                target="_blank"
              >
                Tovább az útmutatóhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 5" style="margin-top: 100px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/ESG_korkep_2024.jpg" class="img-fluid img-style-2" />
          </b-col>
          <b-col cols="12" lg="10" class="custom-col text-maximized pt-1 pb-3">
            <h3>ESG körkép 2024</h3>
            <h3 class="h3-text">A magyar vállalatok fenntarthatóságának helyzete és kilátásai</h3>
            <div class="text-content">
              <p>
                Az ESG és általában a fenntarthatóság a hazai vállalatok számára is megkerülhetetlen feladat. Egyelőre
                kevés hazai cég érintett, de ezek köre biztos, hogy bővülni fog már 2025-től. Ugyanakkor fontos azt
                tudni, hogy a vállalatok hol tartanak a felzárkózási folyamatban, vannak-e egyenetlenségek és hol tudja
                segíteni az akadémiai szféra, a gazdaságpolitika és a különböző testületek a fejlődést. Jelen kiadvány
                ennek feltérképezésére tett kísérletet. Egy megközelítést ad a felkészüléshez és a felkészítéséhez már
                csak azért is, mert az adatok elemzésének egyik fő tanulsága, hogy jellemzően nincs cégeknek
                stratégiájuk a felkészülésre.
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/ESG_K%C3%B6rk%C3%A9p_2024.pdf" target="_blank">
                Tovább a kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 6" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/fenntartasi_jelentes_v2.jpg" class="img-fluid" />
          </b-col>
          <b-col cols="12" lg="10" class="custom-col text-maximized pt-5 pb-5">
            <h3>Fenntarthatósági jelentéstételi útmutató</h3>
            <div class="text-content">
              <p class="short-text">
                Egyre nagyobb a befektetői elvárás a társaságok felé, hogy hosszútávú stratégiáikat ESG alapelvek mentén
                alakítsák ki, és ennek való megfelelésüket átlátható módon kövessék nyomon...
              </p>
              <p class="full-text" style="display: none;">
                Egyre nagyobb a befektetői elvárás a társaságok felé, hogy hosszútávú stratégiáikat ESG alapelvek mentén
                alakítsák ki, és ennek való megfelelésüket átlátható módon kövessék nyomon. Kormányzati oldalról is
                folyamatosan szélesedő és mélyülő jogszabályi előírásokkal követelik meg a nyilvános társaságoktól a
                fenntarthatósági elvárásoknak való megfelelést, ezért elengedhetetlen, hogy a vállalatok minél több nem
                pénzügyi, fenntarthatósághoz kapcsolódó információt tegyenek közzé magukról.
                <br />
                Jelen Útmutató célja, hogy segítséget nyújtson az érdeklődőknek és a BÉT-re bevezetett értékpapírok
                kibocsátóinak abban, hogy fenntarthatósági jelentéseiket elkészítsék.
              </p>
            </div>
            <span>
              <a
                class="link-text"
                href="https://www.bet.hu/Kibocsatok/Ajanlasok-kibocsatoknak/bet-esg-/fenntarthatosagi-jelentesteteli-utmutato-uj"
                target="_blank"
              >
                Tovább az útmutatóhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 7" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/7_Fenntarthato_fejlodesi_celok.jpg" class="img-fluid img-style" />
          </b-col>
          <b-col cols="12" lg="10" class="custom-col text-maximized mb-4 pb-5">
            <h3>Fenntartható Fejlődési Célok és a kkv-k</h3>
            <div class="text-content">
              <p class="short-text">
                Sok kis- és középvállalkozás növekedésének kulcsa az ország határain túli kereslet kiszolgálása. A
                külpiacra lépés piaci előnyhöz juttattja a gazdasági társaságokat, ugyanakkor fontos ismerni az export
                tevékenységgel járó nehézségeket is. A HEPA Magyar Exportfejlesztési Ügynökség Exportakadémia Képzési
                Központja és az Enterprise Europe Network gondozásában megjelenő Export Kisokos sorozat ezen kiadványa a
                Fenntartható Fejlődési Célok alapjaival ismerteti meg a vállalkozót...
              </p>
              <p class="full-text" style="display: none;">
                Sok kis- és középvállalkozás növekedésének kulcsa az ország határain túli kereslet kiszolgálása. A
                külpiacra lépés piaci előnyhöz juttattja a gazdasági társaságokat, ugyanakkor fontos ismerni az export
                tevékenységgel járó nehézségeket is. A HEPA Magyar Exportfejlesztési Ügynökség Exportakadémia Képzési
                Központja és az Enterprise Europe Network gondozásában megjelenő Export Kisokos sorozat ezen kiadványa a
                Fenntartható Fejlődési Célok alapjaival ismerteti meg a vállalkozót. Az ENSZ által kidolgozott összesen
                17 cél és 169 alcél végrehajtásának elsődleges felelősei a kormányok, ugyanakkor a vállalatoknak érdemes
                megismernie melyek azok a célok, amelyek a 2030-ig terjedő időszakban kormányzati fókuszt kapnak, hiszen
                ezek a vállalati környezetre, piaci folyamatokra is hatást gyakorolnak.
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/7_Fenntarthato_fejlodesi_celok.pdf" target="_blank">
                Tovább a kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 8" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/8_Fenntarthatosagi_kezikonyv.png" class="img-fluid img-style" />
          </b-col>
          <b-col cols="12" lg="10" class="custom-col text-maximized mb-2 pb-5">
            <h3>Fenntarthatósági kézikönyv (2022)</h3>
            <div class="text-content">
              <p>
                A Kézikönyv vállalta, hogy a gazdasági, társadalmi, ökológiai kérdések összefüggésében a fenntarthatóság
                jelentőségére rávilágítson, és vállalati szinten is megteremtse a közös tudást az egyes védendő elemeket
                illető kötelezettségek és lehetőségek kérdéskörében. Külön eligazítást ad a kapcsolódó stratégiák,
                jogszabályok és tanúsítványok tekintetében, felvillantva a kapcsolódó intézményi hátteret is. Átfogó
                képest és tudást ad nemcsak a jelen, hanem a fenntartható jövő országunkat érintő kihívásainak
                megválaszolásához.
              </p>
            </div>
            <span>
              <a
                class="link-text"
                href="https://play.google.com/books/reader?id=1o5sEAAAQBAJ&pg=GBS.PA1&hl=hu"
                target="_blank"
              >
                Tovább a kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="text-left 9" style="margin-top: 50px;">
        <b-row class="mb-3 mb-md-5">
          <b-col cols="12" lg="2" class="p-2 d-lg-flex justify-content-end d-none">
            <img src="../assets/img/zold_marketing.png" class="img-fluid img-style" />
          </b-col>
          <b-col cols="12" lg="10" class="custom-col text-maximized mb-4 pb-5">
            <h3>
              Zöld Marketing - A Gazdasági Versenyhivatal tanácsai vállalkozásoknak
            </h3>
            <div class="text-content">
              <p class="short-text">
                Az elmúlt években készült piackutatások szerint növekvő elvárás a fogyasztók részéről a gyártók
                környezetbarát működése, ezzel egyidejűleg pedig növekszik azon vásárlók aránya, akik figyelembe veszik
                fogyasztásuk környezetre gyakorolt hatását. A Gazdasági Versenyhivatal (GVH) több piacon is észlelte,
                hogy egyre elterjedtebb gyakorlat a termékek, szolgáltatások vagy a vállalkozás működésének
                környezetbarát, fenntartható jellegére utaló állításokkal történő népszerűsítése.
              </p>
              <p class="full-text" style="display: none;">
                Az elmúlt években készült piackutatások szerint növekvő elvárás a fogyasztók részéről a gyártók
                környezetbarát működése, ezzel egyidejűleg pedig növekszik azon vásárlók aránya, akik figyelembe veszik
                fogyasztásuk környezetre gyakorolt hatását. A Gazdasági Versenyhivatal (GVH) több piacon is észlelte,
                hogy egyre elterjedtebb gyakorlat a termékek, szolgáltatások vagy a vállalkozás működésének
                környezetbarát, fenntartható jellegére utaló állításokkal történő népszerűsítése. Jelen tájékoztató
                ahhoz kíván segítséget nyújtani, hogy a kereskedelmi kommunikációk tervezése és közzététele során milyen
                szempontokat érdemes szem előtt tartania a vállalkozásoknak a jogsértés elkerülése érdekében. A GVH
                célja ezzel a vállalkozások tisztességes piaci versenyének minél hatékonyabb támogatása a fogyasztók
                tudatosságának növelése mellett.
              </p>
            </div>
            <span>
              <a class="link-text" href="https://vali.hu/static/9_Zold_marketing.pdf" target="_blank">
                Tovább a kiadványhoz &rarr;
              </a>
            </span>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-row id="doc_downloads" cols="12" class="text-left mb-4">
      <b-col lg="6">
        <h3 class="pb-3 mb-2" style="font-size: 22px;">
          <strong>Akkreditációs kérelemhez kapcsolódó dokumentumok</strong>
        </h3>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/ESG_Akkreditacios_kerelem.pdf"
              >
                Akkreditációs kérelem
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/ESG_Megfelelesi_nyilatkozat.pdf"
              >
                Megfelelési nyilatkozat
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/ESG_Akkreditacios_eljaras_tajekoztato.pdf"
              >
                Akkreditációs eljárás tájékoztató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Hivatali_kapu_tajekoztato.pdf"
              >
                Hivatali kapu tájékoztató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Kerdesek_es_valaszok_akkreditalt_intezmenyeknek.pdf"
              >
                Kérdések és válaszok akkreditált intézményeknek
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>

    <div class="pb-1 pt-5">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-5 mt-3">
          <b-col cols="12" lg="8">
            <h3 class="mb-4"><strong>E-learning oktatóanyag:</strong> a Fenntartható vállalkozás</h3>
            <ul class="mb-4">
              <li>az emberi tevékenység környezeti hatásai</li>
              <li>a vállalati felelősség és a jogszabályi háttér</li>
              <li>támogató intézmények és a pályázati-finanszírozási lehetőségek</li>
              <li>mi az ESG és mit tegyen a kkv?</li>
              <li>
                <span>
                  kulcsfogalmak: életciklus-szemlélet, körforgásos gazdaság, ökodizájn, társadalmi felelősségvállalás,
                  társadalmi vállalkozások, zöldremosás
                </span>
              </li>
              <li>hazai jó gyakorlatok és példák</li>
            </ul>
            <b-button
              class="button w-100 w-md-100 mt-4 mb-4"
              href="https://ekkv.hu/fenntarthato-vallalkozas"
              target="_blank"
            >
              Elkezdem a képzést
            </b-button>
          </b-col>
          <b-col offset="1" cols="3" class="p-0 justify-content-end d-lg-block d-none">
            <img src="../assets/img/corp.svg" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <ESGButton />
  </b-container>
</template>

<script>
import ESGButton from './ESGButton.vue'
export default {
  name: 'ESGKezikonyvek',
  components: {
    ESGButton
  }
}
</script>

<style scoped>
/* Szöveg maximalizálása: Növeljük a szöveg oszlop padding/margin-jét minimálisra, hogy több helyet foglaljon el */
.text-maximized {
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.text-maximized-2 {
  padding-left: 0 !important;
  padding-right: 200px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.custom-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  transform: translateX(10px);
}

/* Hover effektek a szöveg bővítéséhez */
.text-content {
  position: relative;
  transition: all 0.5s ease;
}

.text-content:hover .short-text {
  display: none;
}

.text-content:hover .full-text {
  display: block !important;
  animation: fadeIn 0.5s ease;
}

.img-style-4 {
  width: 307px !important;
  max-width: none !important;
  margin-left: -155px;
  display: block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

ul {
  list-style-image: url('../assets/img/icons/tick_mark.svg');
}

.download ul {
  list-style-type: none;
  list-style-image: none;
  padding: 0;
}

.download li {
  font-weight: 700;
  background: #f2f8fa;
}

li {
  padding-left: 20px;
  margin-bottom: 10px;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 24px;
  padding-right: 24px;
}

.link-text {
  font-size: larger;
  font-weight: bold;
}

@media (max-width: 575px) {
  h1 {
    font-size: 24px;
    font-weight: 400;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  h3 {
    font-size: 18px;
    font-weight: 700;
  }
  .text-content:hover .short-text {
    display: none !important;
  }
  .text-content:hover .full-text {
    display: block !important;
  }
  .text-maximized-2 {
    padding-left: 15px !important;
    padding-right: 15px !important;
    max-width: 100%;
  }
}

.button {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  height: 48px;
  line-height: 32px;
  border-radius: 8px;
}

.h3-text {
  font-size: 18px;
}

.img-style {
  max-width: 100%;
  max-height: 500px;
}

.img-style-2 {
  max-width: 60%;
}

.img-style-3 {
  max-width: 300px;
}

.img-style-4 {
  max-width: 300px;
}

.img-fluid {
  max-width: 200px;
  height: 250px;
}
</style>
